import React, { useState, useRef, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './VideoCarousel.css';

export default function VideoCarousel({ data, points = [] }) {
  const [currentVideo, setCurrentVideo] = useState(0);
  const [isFading, setIsFading] = useState(false); // State for fade effect
  const videoRefs = useRef([]);

  const videoUrls = data || [];

  // Handle video transition with fade effect
  const changeVideo = (newIndex) => {
    setIsFading(true); // Start fade to black
    setTimeout(() => {
      setCurrentVideo(newIndex); // Change the video after 1 second
      setIsFading(false); // Fade back in
    }, 1000); // 1 second fade duration
  };

  // Move to next video when current one ends
  const handleVideoEnd = () => {
    changeVideo((currentVideo + 1) % videoUrls.length);
  };

  // Manual navigation
  const handlePrevClick = () => {
    changeVideo(currentVideo === 0 ? videoUrls.length - 1 : currentVideo - 1);
  };

  const handleNextClick = () => {
    changeVideo((currentVideo + 1) % videoUrls.length);
  };

  // Auto-play the current video
  useEffect(() => {
    videoRefs.current.forEach((video, index) => {
      if (video) {
        if (index === currentVideo) {
          video.play().catch((error) => console.error("Autoplay blocked:", error));
        } else {
          video.pause();
          video.currentTime = 0; // Reset non-active videos
        }
      }
    });
  }, [currentVideo]);

  return (
    <div className="video-carousel-container">
      {videoUrls.length > 0 ? (
        <>
          {/* Fade to Black Overlay */}
          <div className={`fade-overlay ${isFading ? "active" : ""}`}></div>

          {/* Navigation Arrows */}
          

          <div className="video-carousel">
            {videoUrls.map((videoUrl, index) => (
              <video
                key={index}
                ref={(el) => (videoRefs.current[index] = el)}
                src={videoUrl}
                autoPlay={index === currentVideo}
                muted
                onEnded={handleVideoEnd}
                className={index === currentVideo ? "active" : "hidden"}
              />
            ))}
          </div>

          

          {/* Dot Indicators */}
          <div className="dots">
            {videoUrls.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentVideo ? 'active' : ''}`}
                onClick={() => changeVideo(index)}
              />
            ))}
          </div>

          {/* Marketing Feature Text */}
          <div className="video-features">
            {points[currentVideo] && <p>{points[currentVideo]}</p>}
          </div>
        </>
      ) : (
        <p>Loading videos...</p>
      )}
    </div>
  );
}
